export * from './actions';
export * from './effects';
export * from './service';

export { featureKey as loginKey, initialState as loginInitialState, State as LoginState } from './reducer';

export {
  getData as loginGetData,
  getError as loginGetError,
  getLoading as loginGetLoading,
  mapData as loginMapData,
} from './selectors';
